import { styled } from '@mui/system';
import { Card } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
     maxWidth: "800px",
     height: '100%',
     backgroundColor: theme.palette.mode === 'light' 
        ? 'rgba(218, 218, 218, 0.8)' 
        : 'rgba(42, 45, 50, 0.8)',
     borderTop: `solid 1px ${theme.palette.mode === 'light' 
        ? 'rgba(93, 103, 109, 0.2)' 
        : 'rgba(255, 255, 255, 0.1)'}`,
     borderBottom: `solid 1px ${theme.palette.mode === 'light' 
        ? 'rgba(93, 103, 109, 0.2)' 
        : 'rgba(255, 255, 255, 0.1)'}`,
     borderLeft: `solid .5px ${theme.palette.mode === 'light' 
        ? 'rgba(93, 103, 109, 0.2)' 
        : 'rgba(255, 255, 255, 0.1)'}`,
     borderRight: `solid .5px ${theme.palette.mode === 'light' 
        ? 'rgba(93, 103, 109, 0.2)' 
        : 'rgba(255, 255, 255, 0.1)'}`,
     boxShadow: theme.palette.mode === 'light'
        ? '2px 2px 10px 0 rgba(0,0,0,0.0)'
        : '0 4px 20px 0 rgba(0,0,0,0.2)',
     borderRadius: '15px',
     color: theme.palette.text.primary,
     marginBottom: theme.spacing(2),
     padding: theme.spacing(2),
}));

export default StyledCard;